<template>
    <main class="mx-auto flex max-w-6xl flex-col gap-6 px-3 py-6 md:flex-row md:gap-8 md:px-6 md:py-10">
    <NeonTempPartialsRail :active="active" :sections="sections" @go="go" />
    <div class="flex min-w-0 flex-1 flex-col gap-6 md:gap-8 [&>section]:flex [&>section]:min-h-dvh
                [&>section]:flex-col [&>section]:justify-center [&>section]:[scroll-snap-align:center]
                [&>section]:[scroll-snap-stop:always] [&>footer]:[scroll-snap-align:end]
                [&>footer]:[scroll-snap-stop:always]">
      <NeonTempPartialsHero v-if="hasSection('hero')" />
      <NeonTempPartialsAboutMe />
      <NeonTempPartialsSkills />
      <NeonTempPartialsServices v-if="hasSection('services')" />
      <NeonTempPartialsProjects v-if="hasSection('projects')" />
      <NeonTempPartialsContacts v-if="hasSection('contact')" />
      <SharedSiteFooter />
      
      <!-- <SiteFooter />  -->
    </div>
  </main>
</template>

<script lang="ts" setup>
const portfolioStore = usePortfolioStore()
const supportedSections = ['hero', 'about', 'skills', 'services', 'projects', 'contact']
const sections = computed(() => {
  const visibleSections = new Set(portfolioStore.visibleSections)

  return supportedSections.filter(
    section =>
      visibleSections.has(section) ||
      ['about', 'skills'].includes(section)
  )
})
const { active, go } = useActiveSection(sections)
const hasSection = (section: string) => sections.value.includes(section)

onMounted(() => document.documentElement.classList.add('t1-snap'))
onBeforeUnmount(() => document.documentElement.classList.remove('t1-snap'))
</script>

<style>

</style>
